import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import TitleWithBack from '../../components/common/TitleWithBack';

function ExamCentresEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [centreData, setCentreData] = useState({
    centreName: '',
    location: '',
    centreNumber: ''
  });
  const [loading, setLoading] = useState(true);
  const [tooltip, setTooltip] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`/api/exam-centres/${id}`)
      .then(response => {
        const data = response.data;
        setCentreData({
          centreName: data.centreName || '',
          location: data.location || '',
          centreNumber: data.centreNumber != null ? data.centreNumber.toString() : ''
        });
        setLoading(false);
      })
      .catch(err => {
        setError('Error fetching exam centre data.');
        setLoading(false);
      });
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
      setCentreData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      centreName: centreData.centreName,
      location: centreData.location,
      // Keep centreNumber as string so it can include letters
      centreNumber: centreData.centreNumber
    };
    axios.put(`/api/exam-centres/${id}`, payload)
      .then(() => {
        setTooltip('Exam centre updated successfully!');
        setTimeout(() => navigate('/admin/exam-centres/view'), 2000);
      })
      .catch(err => {
        setError('Error updating exam centre.');
      });
  };

  if (loading) return <div className="container mt-4"><p>Loading exam centre data...</p></div>;
  if (error) return <div className="container mt-4"><p className="text-danger">{error}</p></div>;

  return (
    <div className="container mt-2">
      <TitleWithBack title="Edit Exam Centre" />
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Centre Name</label>
          <input 
            type="text" 
            name="centreName" 
            className="form-control" 
            value={centreData.centreName} 
            onChange={handleChange} 
            required 
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Location</label>
          <input 
            type="text" 
            name="location" 
            className="form-control" 
            value={centreData.location} 
            onChange={handleChange} 
            required 
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Centre Number</label>
          <input 
            type="text" 
            // This ensures we can type letters
            inputMode="text"
            name="centreNumber" 
            className="form-control"  
            value={centreData.centreNumber} 
            onChange={handleChange} 
            required 
          />
        </div>
        <button type="submit" className="btn btn-primary">Update Exam Centre</button>
      </form>
      {tooltip && (
        <div className="mt-3 alert alert-info">
          {tooltip}
        </div>
      )}
    </div>
  );
}

export default ExamCentresEdit;
